import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createMarkup } from '../../../../utils/helpers';
import 'animate.css/animate.min.css';
import './ContactHeader.css';

class ContactHeader extends PureComponent {

    render() {
        const props = this.props;
        const imageBigStyle = {
            backgroundImage: 'url(' + props.backgroundImage + ')',
        };

        return (
            <div className={`hero contact-hero ${props.orientation}`} style={imageBigStyle}>
                <h1 className="hidden">Contact Hudson Pacific Properties</h1>
                <div className="hero-body">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-offset-1-tablet is-10-tablet">
                                <div className="title-wrapper animated fadeInLeft">
                                    <div className="pre-title">
                                        {props.subTitle}
                                    </div>
                                    <div className="big-title" dangerouslySetInnerHTML={createMarkup(props.title)} />
                                    {props.buttonLink && <a className="btn-link button" href={props.buttonLink}>
                                        <span>{props.buttonTitle}</span>
                                    </a>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ContactHeader.propTypes = {
    backgroundImage: PropTypes.string,
    orientation: PropTypes.string,
    subTitle: PropTypes.string,
    title: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonTitle: PropTypes.string,
};

export default ContactHeader;
